export const OPEN_REQUESTS = 'requests';
export const REQUESTS_IN_WORK = 'requests-in-work';
export const ARCHIVED_REQUESTS = 'archived-requests';
export const ACCOUNT = 'account';
